<div id="dark" class="page-background page-alignment">
    <div class="settings">
      <div class="container-fluid reports-container">
        <div class="d-flex align-items-center gap-2">
          <button 
            (click)="selectReport(ReportTabId.TechnicalReport)" 
            class="custom-nav-btn mb-2 mt-2 text-color-theme" 
            *ngIf="hasTechnicalAnalysis" 
            [class.active]="reportTabId == ReportTabId.TechnicalReport">
              {{"TechnicalReport"|translate}}
          </button>
          
          <button 
            (click)="selectReport(ReportTabId.FundmentalReport)"
            class="custom-nav-btn mb-2 mt-2 text-color-theme mx-3" 
            *ngIf="hasFundmentalAnalysis" 
            [class.active]="reportTabId == ReportTabId.FundmentalReport">
              {{ "FundmentalReport" | translate }} 
          </button>
        </div>
        <div class="reports-container_title text-center">
        {{ (reportTabId == ReportTabId.TechnicalReport) ? ("reportsCenter" | translate) : ("fundmentalReportsCenter" | translate) }}
        </div>
        <div class="reports-container_filter my-4">
          <form [formGroup]="searchForm">
            <div class="form-group">
            <div class="row justify-content-between">
              <div class="row col-9">
                <div class="col-3">
                  <label
                    class="text-color-theme required"
                    [ngStyle]="translate.currentLang == 'en' && { float: 'left' }"
                    >{{ "type" | translate }} </label>
                  <ng-select
                    [searchable]="false"
                    class="custom"
                    required
                    formControlName="type"
                    (change)="getTypeNum($event)"
                  >
                    <ng-option *ngFor="let type of types" [value]="type.id">
                      {{ type.name | translate }}
                    </ng-option>
                  </ng-select>
                </div>
  
                <div class="col-3" *ngIf=" (reportTabId == ReportTabId.TechnicalReport) && (searchObj?.type == 1)">
                    <label
                    class="text-color-theme required"
                    [ngStyle]="translate.currentLang == 'en' && { float: 'left' }"
                    >{{ "indexValue" | translate }}</label
                    >
                    <ng-select
                    [searchable]="false"
                    class="custom"
                    (change)="getTypeValue($event)"
                    name="type"
                    >
                    <ng-option *ngFor="let type of indexTypes" [value]="type.id">
                        {{ type.name | translate }}
                    </ng-option>
                    </ng-select>
                </div>
                <div class="col-3" *ngIf=" (reportTabId == ReportTabId.FundmentalReport) && (searchObj?.type == 4)">
                    <label
                    class="text-color-theme required"
                    [ngStyle]="translate.currentLang == 'en' && { float: 'left' }"
                    >{{ "sector" | translate }}</label
                    >
                    <ng-select
                    [searchable]="false"
                    class="custom"
                    (change)="getTypeValue($event)"
                    name="type"
                    >
                    <ng-option *ngFor="let sector of sectors" [value]="sector.id">
                        {{ translate.currentLang == 'ar' ? sector.SectorNameA : sector.SectorNameE }}
                    </ng-option>
                    </ng-select>
                </div>
  
                <div class="col-3" *ngIf="searchObj?.type == 2">
                  <label
                    class="text-color-theme required"
                    [ngStyle]="translate.currentLang == 'en' && { float: 'left' }"
                    >{{ "symbolValue" | translate }}</label
                  >
                  <ng-select
                    [searchable]="true"
                    class="custom"
                    (change)="getTypeValue($event)"
                  >
                    <ng-option
                      *ngFor="let allMarketName of allMarketNames"
                      [value]="allMarketName.SYMBOL_CODE"
                    >
                      {{
                        translate.currentLang == "ar"
                          ? allMarketName.arb_shortname
                          : allMarketName.eng_shortname
                      }}
                    </ng-option>
                  </ng-select>
                </div>
  
                <div
                  class="col-3 d-flex align-items-center justify-content-start alignBtn"
                >
                  <button
                    class="btn btn-primary"
                    [ngStyle]="
                      !searchForm.valid && {
                        'background-color': '#6c757d',
                        color: 'lightgrey',
                        border: '1px solid #6c757d'
                      }
                    "
                    [disabled]="!searchForm.valid"
                    (click)="search()"
                  >
                    {{ "preview" | translate }}
                  </button>
                </div>
              </div>

              <div class="col-3 align-self-end d-flex justify-content-end">
                <span class="text-muted">
                    {{ report.length }} {{'report' | translate}}
                </span>
              </div>
            </div>
            </div>
          </form>
        </div>
        <div
          id="recent-trades"
          class="table-custom"
          style="overflow: auto"
          *ngIf="report.length > 0"
        >
          <table
            datatable
            [dtOptions]="dtOptions"
            class="table table-sm table-dark table-striped"
          >
            <thead>
              <tr class="text-center">
                <th class="fit" *ngFor="let item of cols">
                  {{ item | translate }}
                </th>
                <th><i class="icon fa fa-print px-1"></i> PDF</th>
                <th>{{ "description" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center custom-striped-row-hover" *ngFor="let rowData of rows">
                <td class="fit">
                  {{ rowData.CreateDate | date : "medium" }}
                </td>
                <td class="fit">
                  {{ rowData.title }}
                </td>
                <td class="fit">
                  {{ rowData?.type }}
                </td>
                <td class="clickable" (click)="downloadPDF(rowData)">
                  <i class="fa fa-book fa-lg"></i>
                </td>
                <td class="clickable">
                  <div
                    *ngIf="rowData?.Desc?.ShortDesc || rowData?.Desc?.Desc"
                    (click)="openDescModal(rowData?.Desc)"
                  >
                    <i class="fa fa-book fa-lg"></i>
                  </div>
                </td>
              </tr>
              
            </tbody>
          </table>
        </div>
        <div
          *ngIf="report.length == 0"
          class="text-center m-5 mx-auto"
          style="width: 60%"
        >
          <img class="empty-state" src="/assets/img/noData.png" />
          <div class="col-sm-12">
            <ng-container *ngIf="!searchObj?.type">
              <ng-container *ngIf="!(noDataFound && report.length == 0)">
                <h6 class="info-warning mt-2">
                  {{ "selectTypeMsg" | translate }}
                </h6>
              </ng-container>
            </ng-container>
            <!-- <h6 class="info-warning mt-2" *ngIf="!searchObj?.type || (noDataFound && report.length==0)">{{ "selectTypeMsg" | translate }}</h6> -->
            <h6 class="info-warning mt-2" *ngIf="noDataFound">
              {{ "noDataFound" | translate }}
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <ngx-loading
    [show]="loading"
    [config]="{ backdropBorderRadius: '3px' }"
  ></ngx-loading>
  